import { render, staticRenderFns } from "./OnboardingChips.vue?vue&type=template&id=c4179c44&scoped=true&"
import script from "./OnboardingChips.vue?vue&type=script&lang=js&"
export * from "./OnboardingChips.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingChips.vue?vue&type=style&index=0&id=c4179c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4179c44",
  null
  
)

export default component.exports